import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { logout } from '../actions/constants'
import {
  DEFAULT_PINCODE_ICON,
  PincodeIconName
} from '../../utils/pincode_icon'
import { ThemeMode } from '../../utils/colors'

export interface ISetupState {
  pincode?: string
  pincodeIcon: PincodeIconName
  themeMode?: ThemeMode
}

const initialState: ISetupState = {
  pincode: undefined,
  pincodeIcon: DEFAULT_PINCODE_ICON,
  themeMode: undefined
}

export const setupSlice = createSlice({
  name: 'setup',
  initialState,
  reducers: {
    setPincode: (state, action: PayloadAction<string | undefined>) => {
      state.pincode = action.payload
    },
    setPincodeIcon: (state, action: PayloadAction<PincodeIconName>) => {
      state.pincodeIcon = action.payload
    },
    setThemeMode: (state, action: PayloadAction<ThemeMode | undefined>) => {
      state.themeMode = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState)
  }
})

export const {
  setPincode,
  setPincodeIcon,
  setThemeMode
} = setupSlice.actions

export default setupSlice.reducer
